import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useReadingActivity() {
  return useQuery({
    queryKey: ['profile', 'reading-activity'],
    queryFn: () => libraryApi.getReadingActivity(),
    staleTime: 5 * 60 * 1000,
  });
}
